<template>
  <PhoneWrapper node-name="НОДА: ИЗМЕНЕНИЕ ДАННЫХ. ПРЕСЕТ: ПАРОЛЬ. ЭКРАН 1: ТЕКУЩИЙ ПАРОЛЬ.">
    <div class="phone-screen__context">
      <ProfileHeader title="Change password"/>

      <p class="phone-screen__title mt-4">Set up your new password</p>

      <bpmInput placeholder="Enter password" class="mt-3" />
      <bpmInput placeholder="Repeat password" class="mt-3" />

      <p class="phone-screen__small-text mt-3"><strong>Note: </strong>Password must be of at least 8 characters
        and should contain at least one capital letter
        and one number.</p>

      <bpmButton class="mt-auto mb-10" style="width: 100%">
        <template v-slot:content><span style="color: white">Set up</span></template>
      </bpmButton>
    </div>
  </PhoneWrapper>
</template>

<script>
import PhoneWrapper from "@/components/utils/PhoneWrapper.vue";
import ProfileHeader from "@/components/nodes/creditLine/widgets/transh/ProfileHeader.vue";
export default {
  name: "SetPassword",
  components: {PhoneWrapper, ProfileHeader}
}
</script>